import React from 'react'

export const Loader = () => {
  return (
    <div class="loader">
    <div class="loader-inner"></div>
    </div>
  )
}
